import React, { useState, useRef } from 'react';

export default function QuestionCard({ question, onSubmit, disabled }) {
  const [selected, setSelected] = useState(null);
  const scenarioRef = useRef(null);

  const options = question.options || [];

  const handleSubmit = () => {
    if (!selected || disabled) return;
    onSubmit(selected);
  };

  // Text highlight on mouseup within the scenario
  const handleScenarioMouseUp = () => {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return;
    if (!scenarioRef.current) return;

    // Check if selection is within our scenario div
    const range = selection.getRangeAt(0);
    if (!scenarioRef.current.contains(range.commonAncestorContainer)) return;

    // Wrap selected text in a <mark>
    try {
      const mark = document.createElement('mark');
      mark.className = 'qp-highlight';
      range.surroundContents(mark);
      selection.removeAllRanges();
    } catch (e) {
      // surroundContents fails if selection spans multiple elements — ignore
    }
  };

  return (
    <div className="qp-card">
      {question.scenario && (
        <div
          ref={scenarioRef}
          className="qp-scenario"
          onMouseUp={handleScenarioMouseUp}
        >
          {question.scenario}
        </div>
      )}
      <div className="qp-stem">{question.stem}</div>
      <div className="qp-options">
        {options.map(opt => {
          const letter = opt.letter;
          const isSelected = selected === letter;
          return (
            <button
              key={letter}
              className={`qp-option ${isSelected ? 'qp-option-selected' : ''}`}
              onClick={() => !disabled && setSelected(letter)}
              disabled={disabled}
            >
              <span className="qp-option-letter">{letter}</span>
              <span className="qp-option-text">{opt.text}</span>
            </button>
          );
        })}
      </div>
      <div className="qp-submit-row">
        <button
          className="btn-primary"
          onClick={handleSubmit}
          disabled={!selected || disabled}
        >
          Submit answer
        </button>
      </div>
    </div>
  );
}
